import apiClient from './apiClient';

// System configuration API
export const getSystemConfig = async () => {
    const response = await apiClient.get('/api/v1/system/config');
    return response.data;
};

export const updateSystemConfig = async (config) => {
    const response = await apiClient.post('/api/v1/system/config', config);
    return response.data;
};

// System status API
export const getSystemStatus = async () => {
    const response = await apiClient.get('/api/v1/system/status');
    return response.data;
};

// Client maintenance API
export const getClientMaintenance = async () => {
    const response = await apiClient.get('/api/v1/system/maintenance/clients');
    return response.data;
};

export const updateClientMaintenance = async (clientIds) => {
    const response = await apiClient.post('/api/v1/system/maintenance/clients', {
        clientIds: clientIds
    });
    return response.data;
};

export const disableClientMaintenance = async () => {
    const response = await apiClient.delete('/api/v1/system/maintenance/clients');
    return response.data;
};

export const checkClientMaintenance = async (clientId) => {
    const response = await apiClient.get(`/api/v1/system/maintenance/clients/${clientId}`);
    return response.data;
};

// Customers API
export const getCustomers = async () => {
    const response = await apiClient.get('/api/v1/customers');
    return response.data;
};

// API Management API
export const getApiEndpoints = async () => {
    const response = await apiClient.get('/api/v1/api-management/endpoints');
    return response.data;
};

export const updateRateLimiting = async (settings) => {
    console.log('🌐 API: Sending rate limiting settings to backend:', settings);
    console.log('🌐 API: Endpoint: POST /api/v1/system/config');
    const response = await apiClient.post('/api/v1/system/config', settings);
    console.log('🌐 API: Backend response:', response.data);
    return response.data;
};

// Database API
export const getDatabaseStatus = async (clientId = null) => {
    const url = clientId ? `/api/v1/database/status?clientId=${clientId}` : '/api/v1/database/status';
    const response = await apiClient.get(url);
    return response.data;
};

export const performDatabaseAction = async (action) => {
    const response = await apiClient.post('/api/v1/database/actions', { action });
    return response.data;
};

// Security API
export const getSecurityMetrics = async (from, to) => {
    const response = await apiClient.get(`/api/v1/security/metrics?from=${from}&to=${to}`);
    return response.data;
};
